import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const wheelTorqueService = {
    getAllTorques,
    getTorque,
    updateTorque,
    createTorque,
    updateTorqueStatus
};

const MODULE = {
    TORQUE: 'wheel-torques',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllTorques(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
      }
    }
    
    let array = filter.searchArray
    array.forEach((word, index) => {
      if(word != null || word != '')
      {
        var searchParam = `search_words[${index}]`
        requestOptions.params[searchParam] = word
      }
    })
  
    return apiHelper(API_URL).get(`/${MODULE.TORQUE}`, requestOptions)
  }

  export function getTorque(id) {   
    return apiHelper(API_URL).get(`/${MODULE.TORQUE}/${id}`)
  }

  export function updateTorque(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).put(`/${MODULE.TORQUE}/${data.id}`, requestOptions)
  }

  export function createTorque(data) {
    const requestOptions = {
      name: data.name,
    }
  
    return apiHelper(API_URL).post(`/${MODULE.TORQUE}`, requestOptions)
  }

  export function updateTorqueStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
    
    return apiHelper(API_URL).patch(`/${MODULE.TORQUE}/${data.id}`, requestOptions)
    
  }